module.exports = __webpack_public_path__ + "static/img/Jean_Sibelius.e627df4.jpg";